import { t } from 'i18next'
import * as React from 'react'
import { any, fromJSX } from 'widgets-for-react'
import { ExternalLink } from '../../components/publicSite/utils/external_link'
import { titleSplit } from '../../components/publicSite/utils/helpers'
import { FakeCMSState, FakeTextBlock, FakeTextImageLeftBlock } from '../fake_data/buildingblocks'
import { applyBlock } from '../fake_data/fakeApplyBlock'
import { gridHighlightBlock } from '../fake_data/fakeGridHighlight'
import { recruitmentBlock } from '../fake_data/fakeRecruitmentBlock'
import { footer } from '../fake_data/footer'
import { header } from '../fake_data/header'
import { linkBackAnchor } from '../fake_data/links'
import { pageheader } from '../fake_data/pageheader'
import { vacanciesOverview } from '../fake_data/vacanciesOverview'
import { vacancySearch } from '../fake_data/vacancySearchForm'
import { styleguideChapter, styleguideExample, styleguidePart, styleguideSection } from '../helpers.mod'
import { allLanguages, localeISOcodes, localeTranslations } from '../../components/publicSite/utils/history.mod'

export const styleguideCompositions = styleguideChapter({
  type: 'compositions',
  slug: 'compositions',
  title: 'Design Compositions',
  intro: ''
})(
  any([
    styleguideSection({ type: 'compositions', slug: 'compositions-vacancies', title: 'Vacancies', intro: '' })(
      any([
        styleguidePart({ title: 'Detail Page', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: true })(
            fromJSX((_) => (
              <body id="react-content">
                {header({ menuOpen: false })}
                <main id="a11y-main" className="main main--vacancy">
                  {pageheader(false, false, true)}
                  <div className="page__content">
                    {linkBackAnchor()}
                    {FakeTextBlock(FakeCMSState).run(_)}
                    {FakeTextBlock(FakeCMSState).run(_)}
                    {FakeTextBlock(FakeCMSState).run(_)}
                    {recruitmentBlock()}
                    {applyBlock()}
                  </div>
                </main>
                {footer()}
              </body>
            ))
          )
        ),
        styleguidePart({ title: 'Overview Page', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: true })(
            fromJSX(() => (
              <body id="react-content">
                {header({ menuOpen: false })}
                <main id="a11y-main" className="main main--page">
                  {pageheader(false)}
                  {vacancySearch()}
                  {vacanciesOverview()}
                </main>
                {footer()}
              </body>
            ))
          )
        )
      ])
    ),
    styleguideSection({ type: 'compositions', slug: 'compositions-vacancy-landing', title: 'Vacancies', intro: '' })(
      styleguidePart({ title: 'Landing Page', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: true })(
          fromJSX((_) => (
            <body id="react-content">
              {header({ menuOpen: false })}
              <main id="a11y-main" className="main main--page">
                {pageheader(true, true)}
                {gridHighlightBlock()}
                {FakeTextImageLeftBlock(FakeCMSState).run(_)}
              </main>
              {footer()}
            </body>
          ))
        )
      )
    ),
    styleguideSection({
      type: 'compositions',
      slug: 'compositions-locales',
      title: 'Select Locale Page',
      intro: ''
    })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: true })(
            fromJSX(() => (
              <body id="react-content">
                <header className="header">
                  <div className="header__inner">
                    <div className="header__toolbar">
                      <div className="header__logo-toggler">
                        <a className="header__logo" href={'/'}>
                          <span className="sr-text">{t('header:returnToHome')}</span>
                          <img src="/images/logo--color.svg" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </header>
                <main id="a11y-main" className="main main--locales">
                  <div className="main__inner">
                    <article className="page">
                      <div className="page__inner">
                        <header className="pageheader pageheader--text cf">
                          <div className="pageheader__inner bg--green-400">
                            <div className="pageheader__title container container--m gutter--3-5">
                              <h1 className="title--l">{titleSplit(t('SelectLocale:title'))}</h1>
                            </div>
                          </div>
                        </header>
                        <div className="page__content">
                          <div className="container container--m gutter--3-2">
                            <ul className="locales__list blocklist">
                              {allLanguages.map((locale) => (
                                <li className="locales__item blocklist__item">
                                  <a className="blocklist__link" href="#">
                                    <span lang={localeISOcodes.get(locale)}>{localeTranslations.get(locale)}</span>
                                    {locale === 'global' ? (
                                      <svg
                                        className="blocklist__icon"
                                        width="1.5rem"
                                        height="1.5rem"
                                        aria-hidden="true"
                                      >
                                        <use xlinkHref="#icon--global" />
                                      </svg>
                                    ) : (
                                      <img className="blocklist__image" alt="" src={`./images/flags/${locale}.jpg`} />
                                    )}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </article>
                  </div>
                </main>
              </body>
            ))
          )
        )
      ])
    ),
    styleguideSection({ type: 'compositions', slug: 'compositions-404', title: '404 Page', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: true })(
            fromJSX(() => (
              <body id="react-content">
                {header({ menuOpen: false })}
                <main id="a11y-main" className="main main--error">
                  <div className="main__inner">
                    <article className="page">
                      <div className="page__inner">
                        <header className="pageheader pageheader--text cf">
                          <div className="pageheader__inner bg--green-400">
                            <div className="pageheader__title container container--m gutter--3-5">
                              <nav className="breadcrumb label--s">
                                <div className="breadcrumb__inner">
                                  <ul className="breadcrumb__items">
                                    <li className="breadcrumb__item">
                                      <ExternalLink
                                        type="link"
                                        to=""
                                        className="breadcrumb__link"
                                        aria-current="location"
                                      >
                                        <span className="breadcrumb__label">
                                          404 <span className="breadcrumb__icon">/</span>
                                        </span>
                                      </ExternalLink>
                                    </li>
                                  </ul>
                                </div>
                              </nav>
                              <h1 className="title--l">{titleSplit(t('Common:404.Title'))}</h1>
                            </div>
                          </div>

                          <div className="pageheader__content container container--m gutter--3-5">
                            <p
                              className="pageheader__intro text--styled"
                              dangerouslySetInnerHTML={{ __html: t('Common:404.Text') }}
                            ></p>
                          </div>
                        </header>
                      </div>
                    </article>
                  </div>
                </main>
                {footer()}
              </body>
            ))
          )
        )
      ])
    )
  ])
)
